import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import GnbCheckerBoardMenuContainer from '@routes/Common/CommonLayout/GnbCheckerBoardMenu/GnbCheckerBoardMenuContainer';
import { useHistory } from 'react-router-dom';

const MyAccountHeader = () => {
  const { headerContainer } = useMyAccountStyles();
  const history = useHistory();
  return (
    <Box className={headerContainer}>
      <CustomizedTypography variant="h4" fontWeight="700" color="textPrimary">
        더보기
      </CustomizedTypography>
      <Box className="btnContainer">
        <CustomizedButton
          className="gnb-blog"
          variant="text"
          onClick={() => {
            history.push('/blog');
          }}
        >
          블로그
        </CustomizedButton>
        <GnbCheckerBoardMenuContainer />
      </Box>
    </Box>
  );
};

export default MyAccountHeader;

const useMyAccountStyles = makeStyles((theme) => ({
  headerContainer: {
    position: 'sticky',
    width: '100%',
    height: 68,
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    backgroundColor: colorSet.gray000,
    zIndex: 3,
    '& .btnContainer': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '12px',
      '& .gnb-blog': {
        color: colorSet.gray700
      }
    }
  }
}));
